import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  addButton: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    textTransform: 'none',
  },
}));
